<mat-dialog-actions class="dialog-actions">
    <nv-button type="secondary" (clickButton)="close()">
        Cancel
    </nv-button>
    <nv-button htmlType="submit" (clickButton)="onClick()" [disabled]="isDisabled">
        {{ confirmationButtonLabel }}
    </nv-button>
</mat-dialog-actions>
